import { SVGAttributes } from "react";

export default (props: SVGAttributes<any>) => {
  return (
    <svg {...props} width="98" height="93" viewBox="0 0 98 93" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M49.7686 87.0205C72.3484 87.0205 90.6529 68.7674 90.6529 46.251C90.6529 23.7346 72.3484 5.48145 49.7686 5.48145C27.1888 5.48145 8.88428 23.7346 8.88428 46.251C8.88428 68.7674 27.1888 87.0205 49.7686 87.0205Z"
        fill="#EAEEF9"
      />
      <g filter="url(#filter0_d_2951_16638)">
        <path
          d="M89.09 32.6338V71.4346C89.09 71.5987 89.09 71.6807 89.09 71.8447C89.0078 74.0596 87.9383 76.0283 86.3754 77.3408C84.9769 78.5713 83.1671 79.3096 81.1928 79.3096H18.5913C17.1928 79.3096 15.9589 78.9815 14.8072 78.3252C14.3136 78.0791 13.8201 77.751 13.4088 77.3408C12.5039 76.6026 11.7635 75.6182 11.3522 74.4697C11.0232 73.6494 10.7764 72.8291 10.7764 71.9268V32.6338C10.7764 32.6338 14.0669 29.8447 18.7558 25.9893C23.6093 21.8877 30.0257 16.6377 35.6196 11.9619C38.8278 9.25488 38.4987 9.58301 43.4345 5.39942C47.2185 2.2002 52.7301 2.2002 56.5142 5.39942C57.5013 6.21973 58.4885 7.12207 59.4756 7.94238C61.5322 9.58301 63.8355 11.5518 66.2211 13.5205C71.2391 17.7041 76.7507 22.2979 81.1106 25.9072C85.5527 29.5986 88.761 32.3057 89.09 32.6338Z"
          fill="#526DFF"
        />
      </g>
      <path
        d="M81.1106 25.9072V39.8525L67.4551 48.0557L63.342 50.5166L54.7044 55.6846L50.5913 58.1455L48.8638 59.2119L47.2186 58.1455L43.3522 55.6846L35.126 50.5166L31.2597 48.0557L18.5913 40.0986V25.9893C23.4448 21.8877 29.8612 16.6377 35.4551 11.9619L66.0566 13.5205C71.3214 17.7041 76.833 22.2979 81.1106 25.9072Z"
        fill="#465DD9"
      />
      <path
        d="M78.3959 14.833V39.2783L65.8921 46.7432L62.1903 48.958L54.2931 53.6338L50.5913 55.8486L49.0283 56.751L47.5476 55.8486L44.0103 53.6338L36.5244 48.958L32.9872 46.7432L21.4705 39.5244V14.833C21.4705 12.29 23.527 10.1572 26.1594 10.1572H73.707C76.2571 10.1572 78.3959 12.29 78.3959 14.833Z"
        fill="white"
      />
      <path
        d="M68.1954 28.2861H33.0694C32.4936 28.2861 32 27.7939 32 27.1377C32 26.4814 32.4936 25.9893 33.0694 25.9893H68.1954C68.7712 25.9893 69.2648 26.4814 69.2648 27.1377C69.2648 27.7939 68.7712 28.2861 68.1954 28.2861Z"
        fill="#E7EBF2"
      />
      <path
        d="M68.1954 35.1768H33.0694C32.4936 35.1768 32 34.6846 32 34.0283C32 33.3721 32.4936 32.8799 33.0694 32.8799H68.1954C68.7712 32.8799 69.2648 33.3721 69.2648 34.0283C69.2648 34.6846 68.7712 35.1768 68.1954 35.1768Z"
        fill="#E7EBF2"
      />
      <path
        d="M68.1954 42.0674H33.0694C32.4936 42.0674 32 41.5752 32 40.9189C32 40.2627 32.4936 39.7705 33.0694 39.7705H68.1954C68.7712 39.7705 69.2648 40.2627 69.2648 40.9189C69.2648 41.5752 68.7712 42.0674 68.1954 42.0674Z"
        fill="#E7EBF2"
      />
      <path d="M65.892 46.7432L62.1902 48.958H36.5243L32.9871 46.7432H33.0693H65.892Z" fill="#E7EBF2" />
      <path d="M54.293 53.6338L50.5912 55.9307H47.5475L44.0103 53.6338H54.293Z" fill="#E7EBF2" />
      <path
        d="M60.6273 20.4111H40.7198C40.144 20.4111 39.6504 19.9189 39.6504 19.2627C39.6504 18.6064 40.144 18.1143 40.7198 18.1143H60.6273C61.2031 18.1143 61.6967 18.6064 61.6967 19.2627C61.6967 19.9189 61.2031 20.4111 60.6273 20.4111Z"
        fill="url(#paint0_linear_2951_16638)"
      />
      <path
        opacity="0.67"
        d="M11.1055 32.4697L48.6993 34.9307L88.5142 32.4697L87.0335 39.6064C87.0335 39.6064 49.6042 59.1299 49.851 59.1299C50.0978 59.1299 11.1877 35.9971 11.1877 35.9971L11.1055 32.4697Z"
        fill="url(#paint1_linear_2951_16638)"
      />
      <path
        d="M89.09 32.6338V71.8447C89.0078 74.0596 87.9383 76.0283 86.3754 77.3408C84.9769 78.5713 83.1671 79.3096 81.1928 79.3096H18.5913C17.1928 79.3096 15.9589 78.9815 14.8072 78.3252C14.3136 78.0791 13.8201 77.751 13.4088 77.3408C12.5039 76.6026 11.7635 75.6182 11.3522 74.4697C11.0232 73.6494 10.7764 72.8291 10.7764 71.9268V71.8447V32.6338L45.8201 54.5361L48.8638 56.4229L49.9332 55.7666L50.9203 55.1924L89.09 32.6338Z"
        fill="#738DFF"
      />
      <path
        d="M86.4576 77.3408C85.0592 78.5713 83.2494 79.3096 81.2751 79.3096H18.5913C17.1928 79.3096 15.9589 78.9815 14.8072 78.3252C14.3136 78.0791 13.8201 77.751 13.4088 77.3408C12.5039 76.6026 11.7635 75.6182 11.3522 74.4697C11.0232 73.6494 10.7764 72.8291 10.7764 71.9268V71.8447V32.6338L14.8895 35.0947L49.9332 55.8486L50.9203 56.4229L51.0026 56.5049L82.4268 75.044L86.4576 77.3408Z"
        fill="url(#paint2_linear_2951_16638)"
      />
      <path
        d="M50.9202 55.1924V57.8994L14.8071 78.3252C14.3135 78.0791 13.8199 77.751 13.4086 77.3408C12.5037 76.6025 11.7634 75.6182 11.3521 74.4697L46.478 53.7158L49.5217 55.6025L49.933 55.7666L50.9202 55.1924Z"
        fill="url(#paint3_linear_2951_16638)"
      />
      <path d="M10.7764 32.6338L49.9332 55.8486" stroke="#A6BDFF" strokeWidth="0.5" strokeMiterlimit="10" />
      <path
        d="M89.09 32.6338V71.8447C89.0077 74.0596 87.9383 76.0283 86.3753 77.3408C84.9768 78.5713 83.1671 79.3096 81.1928 79.3096H18.5912C17.1928 79.3096 15.9588 78.9815 14.8072 78.3252C14.3136 78.0791 13.82 77.751 13.4087 77.3408L17.4395 74.9619L48.8637 56.4229L49.9331 55.7666L50.9203 55.1924L84.9768 35.0127L89.09 32.6338Z"
        fill="url(#paint4_linear_2951_16638)"
      />
      <path
        d="M89.0899 32.6338L50.9203 55.1924L49.9331 55.7666L48.8637 56.4229L13.4087 77.3408"
        stroke="#99B3FF"
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M79.7121 60.0322H58.8998C58.4062 60.0322 57.9949 59.6221 57.9949 59.1299C57.9949 58.6377 58.4062 58.2275 58.8998 58.2275H79.7121C80.2057 58.2275 80.617 58.6377 80.617 59.1299C80.617 59.6221 80.2057 60.0322 79.7121 60.0322Z"
        fill="url(#paint5_linear_2951_16638)"
      />
      <path
        d="M79.7121 66.0205H58.8998C58.4062 66.0205 57.9949 65.6104 57.9949 65.1182C57.9949 64.626 58.4062 64.2158 58.8998 64.2158H79.7121C80.2057 64.2158 80.617 64.626 80.617 65.1182C80.617 65.6104 80.2057 66.0205 79.7121 66.0205Z"
        fill="url(#paint6_linear_2951_16638)"
      />
      <path
        d="M92.874 28.9424C94.6004 28.9424 96 27.5468 96 25.8252C96 24.1036 94.6004 22.708 92.874 22.708C91.1476 22.708 89.748 24.1036 89.748 25.8252C89.748 27.5468 91.1476 28.9424 92.874 28.9424Z"
        fill="#EAEEF9"
      />
      <path
        d="M10.694 17.54C11.8298 17.54 12.7506 16.6219 12.7506 15.4893C12.7506 14.3566 11.8298 13.4385 10.694 13.4385C9.5582 13.4385 8.63745 14.3566 8.63745 15.4893C8.63745 16.6219 9.5582 17.54 10.694 17.54Z"
        fill="#EAEEF9"
      />
      <path
        d="M1.39846 22.79C2.1708 22.79 2.79692 22.1657 2.79692 21.3955C2.79692 20.6253 2.1708 20.001 1.39846 20.001C0.626111 20.001 0 20.6253 0 21.3955C0 22.1657 0.626111 22.79 1.39846 22.79Z"
        fill="#EAEEF9"
      />
      <path
        d="M89.2544 15.7354C89.9813 15.7354 90.5706 15.1477 90.5706 14.4229C90.5706 13.698 89.9813 13.1104 89.2544 13.1104C88.5275 13.1104 87.9382 13.698 87.9382 14.4229C87.9382 15.1477 88.5275 15.7354 89.2544 15.7354Z"
        fill="#EAEEF9"
      />
      <path
        d="M94.5193 58.4736C95.2462 58.4736 95.8355 57.886 95.8355 57.1611C95.8355 56.4363 95.2462 55.8486 94.5193 55.8486C93.7924 55.8486 93.2031 56.4363 93.2031 57.1611C93.2031 57.886 93.7924 58.4736 94.5193 58.4736Z"
        fill="#EAEEF9"
      />
      <path
        opacity="0.3"
        d="M84.9769 35.0127V39.1143L89.09 37.0635V32.6338L84.9769 35.0127ZM84.9769 55.2744V61.919L89.09 59.8682V53.2236L84.9769 55.2744ZM84.9769 66.5947V71.6807C84.8946 72.2549 84.7301 72.9111 84.4011 73.4033C84.3188 73.4854 84.3188 73.5674 84.2365 73.6494L89.09 71.1885V64.544L84.9769 66.5947ZM83.9898 78.4893L82.7558 79.1455C84.1543 78.8994 85.306 78.2432 86.3754 77.4229C86.3754 77.4229 86.3754 77.4229 86.4576 77.4229C86.5399 77.4229 86.5399 77.3408 86.6222 77.2588L83.9898 78.4893ZM10.7764 66.3486V71.8447V71.9268C10.7764 72.2549 10.8586 72.583 10.9409 72.9111L14.8895 70.8604V64.2158L10.7764 66.3486ZM10.7764 43.544V50.1885L14.8895 48.1377V41.4932L10.7764 43.544ZM10.7764 32.6338V38.8682L14.8895 36.8174V35.0947L10.7764 32.6338ZM10.7764 54.9463V61.5908L14.8895 59.54V52.8955L10.7764 54.9463ZM18.5913 75.208C18.18 75.208 17.7687 75.126 17.4396 75.044C17.1928 74.9619 17.0283 74.8799 16.7815 74.7979C16.7815 74.7979 16.7815 74.7979 16.6992 74.7979L12.7507 76.8486C12.9974 77.0947 13.162 77.2588 13.4088 77.5049C13.8201 77.9151 14.3136 78.1611 14.8072 78.4893C15.1363 78.7354 15.5476 78.8994 15.9589 78.9815L23.6093 75.29H18.5913V75.208ZM33.9743 75.208L25.3368 79.3096H34.7147L43.3522 75.208H33.9743ZM53.5527 75.208L44.9152 79.3096H54.2931L62.9306 75.208H53.5527ZM73.2134 75.208L64.5759 79.3096H72.144L80.7815 75.208H73.2134ZM84.9769 43.8721V50.5166L89.09 48.4658V41.8213L84.9769 43.8721Z"
        fill="#526DFF"
      />
      <path
        d="M83.9897 78.4893L86.5399 77.1768C86.4576 77.2588 86.4576 77.2588 86.3754 77.3408C86.3754 77.3408 86.3754 77.3408 86.2931 77.3408L83.9897 78.4893Z"
        fill="#526DFF"
      />
      <defs>
        <filter
          id="filter0_d_2951_16638"
          x="2.77637"
          y="0"
          width="94.3137"
          height="92.3096"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="5" />
          <feGaussianBlur stdDeviation="4" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2951_16638" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2951_16638" result="shape" />
        </filter>
        <linearGradient
          id="paint0_linear_2951_16638"
          x1="39.6673"
          y1="19.2792"
          x2="61.6422"
          y2="19.2792"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF66A9" />
          <stop offset="1" stopColor="#F53689" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2951_16638"
          x1="49.7624"
          y1="67.5258"
          x2="49.7624"
          y2="34.2351"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F6AFF" />
          <stop offset="1" stopColor="#657EFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2951_16638"
          x1="11.6561"
          y1="55.9502"
          x2="88.0316"
          y2="55.9502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83A6FF" />
          <stop offset="1" stopColor="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_2951_16638"
          x1="33.4038"
          y1="68.2808"
          x2="30.3362"
          y2="63.7911"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4F6AFF" />
          <stop offset="1" stopColor="#657EFF" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_2951_16638"
          x1="85.8793"
          y1="55.9502"
          x2="10.9574"
          y2="55.9502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83A6FF" />
          <stop offset="1" stopColor="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_2951_16638"
          x1="57.9425"
          y1="59.1335"
          x2="80.6157"
          y2="59.1335"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83A6FF" />
          <stop offset="1" stopColor="#5A78FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_2951_16638"
          x1="57.9425"
          y1="65.0848"
          x2="80.6157"
          y2="65.0848"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#83A6FF" />
          <stop offset="1" stopColor="#5A78FF" />
        </linearGradient>
      </defs>
    </svg>
  );
};
